import { gql } from '@/shared/graphql/generated/explorer';

export const getTotalBlockCountQuery = gql(/* GraphQL */ `
  query GetTotalBlockCount {
    latestBlock: allBlocks(orderBy: ID_DESC, first: 1) {
      nodes {
        totalCount: id
      }
    }
  }
`);

export const archiveInfoQuery = gql(/* GraphQL */ `
  query ArchiveInfo {
    archiveInfo {
      lastArchivedBlock
    }
  }
`);

export const getAllBlocksQuery = gql(/* GraphQL */ `
  query GetAllBlocks($first: Int!, $offset: Int) {
    allBlocks(orderBy: ID_DESC, offset: $offset, first: $first) {
      pageInfo {
        hasPreviousPage
        startCursor
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...BlockListBlock
        }
      }
    }
  }
`);

// Counts are never served from the archive, so this only ever asks for the unarchived part of
// a page — `archiveInfo.lastArchivedBlock` says where that starts.
export const getBlockCountsQuery = gql(/* GraphQL */ `
  query GetBlockCounts($startBlockHeight: Int!, $endBlockHeight: Int!) {
    getBlockCounts(startBlockHeight: $startBlockHeight, endBlockHeight: $endBlockHeight) {
      blockHeight
      extrinsicsCount
      eventsCount
    }
  }
`);

// The pre-archive way of getting the same two numbers, kept for gateways that do not have
// `archiveInfo`/`getBlockCounts` yet. It fetches every extrinsic and event to count them, so
// it is the fallback rather than the default.
export const getBlocksEventsAndExtrinsicsCount = gql(/* GraphQL */ `
  query getBlocksEventsAndExtrinsicsCount($startBlockHeight: Int!, $endBlockHeight: Int!) {
    getBlocksDetails(startBlockHeight: $startBlockHeight, endBlockHeight: $endBlockHeight) {
      blocks {
        extrinsicsCount
        eventsCount
        blockHeight
      }
    }
  }
`);

export const getBlockByHashQuery = gql(/* GraphQL */ `
  query getBlockByHash($hash: String) {
    blocks: allBlocks(condition: { hash: $hash }, first: 1) {
      nodes {
        ...BlockWithValidator
      }
    }
    eventsAndExtrinsics: getBlockDetails(hash: $hash) {
      ...BlockEventsAndExtrinsics
    }
    lastBlocks: allBlocks(last: 1) {
      nodes {
        id
      }
    }
  }
`);

export const getBlockByIdQuery = gql(/* GraphQL */ `
  query getBlockById($id: Int!) {
    blocks: allBlocks(condition: { id: $id }, first: 1) {
      nodes {
        ...BlockWithValidator
      }
    }
    eventsAndExtrinsics: getBlockDetails(blockHeight: $id) {
      ...BlockEventsAndExtrinsics
    }
    lastBlocks: allBlocks(last: 1) {
      nodes {
        id
      }
    }
  }
`);
